import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

@Component({
  selector: 'app-credit-card-form',
  templateUrl: './credit-card-form.component.html',
  styleUrls: ['./credit-card-form.component.scss'],
})
export class CreditCardFormComponent implements OnInit {
  public creditCardForm: FormGroup;

  public requiredErr: any;


  constructor(private formBuilder: FormBuilder) {
  }

  ngOnInit() {
    this.initForm();
  }

  

  initForm() {
    this.creditCardForm = this.formBuilder.group({
      cardNumber: new FormControl('', Validators.compose([
        Validators.required,
        Validators.pattern(/^\d{16}$/)
      ])),
      cardHolderName: new FormControl('', Validators.compose([
        Validators.required,
      ])),
      expirationDate:  new FormControl('', Validators.compose([
        Validators.required,
        Validators.pattern(/^(0[1-9]|1[0-2])\/\d{2}$/)
      ])),
      cvv: new FormControl('', Validators.compose([
        Validators.required,
        Validators.pattern(/^\d{3}$/)
      ])),
    });
  }

  onSubmit(e) {
    e.preventDefault();
    if (this.creditCardForm.valid) {
      // Handle the form submission here
    } else {
      // Mark form fields as touched to display validation errors
      this.markFormGroupAsTouched(this.creditCardForm);
    }
  }

  markFormGroupAsTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormGroupAsTouched(control);
      }
    });
  }

  showRequiredError(field, input?) {
    if (this.creditCardForm.controls[field].errors && this.creditCardForm.get(field).touched) {
      return input ? true : this.requiredErr;
    }
  }
  showError(controlName: string): boolean {
    return (
      this.creditCardForm.get(controlName)?.invalid &&
      this.creditCardForm.get(controlName)?.touched
    );
  }
}
